import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { ModalInterface } from './modal-for-root.interface';

@Injectable()
export class ModalService {
    private modalOpen: Subject<boolean> = new Subject<boolean>();
    private modalSubject: Subject<ModalInterface> = new Subject<ModalInterface>();
    private existingModalSubject = new Subject<void>();
    currentModal: ModalInterface | null = null;

    constructor() {
        this.modalOpen.subscribe((isOpen) => {
            if (isOpen) {
                document.body.classList.add('freeze');
            } else {
                document.body.classList.remove('freeze');
            }
        });
    }

    closeModal() {
        this.modalOpen.next(false);
        this.modalSubject.next({});
        this.currentModal = null;
    }

    createModal(modal: ModalInterface) {
        this.currentModal = modal;
        this.modalSubject.next(modal);
        this.openModal();
    }

    updateModal(updatedProps: Partial<ModalInterface>) {
        if (this.currentModal) {
            this.currentModal = { ...this.currentModal, ...updatedProps };
            this.modalSubject.next(this.currentModal);
        }
    }

    getModalObservable() {
        return this.modalSubject.asObservable();
    }

    getModalOpenObservable() {
        return this.modalOpen.asObservable();
    }

    openModal() {
        this.modalOpen.next(true);
    }

    openExistingModal() {
        this.existingModalSubject.next();
    }

    getOpenExistingModalSubject() {
        return this.existingModalSubject.asObservable();
    }
}
